module.exports = __webpack_public_path__ + "img/hotel_en_oaxaca-arte.bc83f415.svg";